"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoonaverseApiKey = exports.Build5 = exports.https = void 0;
const interfaces_1 = require("@build-5/interfaces");
const axios_1 = __importDefault(require("axios"));
const https_1 = require("./https");
const https = (origin = Build5.PROD) => new HttpsWrapper(origin);
exports.https = https;
class HttpsWrapper {
    constructor(origin) {
        this.origin = origin;
        this.sendRequest = (name) => async (request) => {
            try {
                const isLocal = !Object.values(Build5).includes(this.origin);
                const url = this.origin + `/${isLocal ? 'https-' : ''}` + name;
                return (await axios_1.default.post(url, request)).data;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }
            catch (error) {
                throw error.response.data;
            }
        };
        this.project = (apiKey) => new https_1.ProjectWrapper(this.origin, apiKey);
        this.createMember = (this.sendRequest(interfaces_1.WEN_FUNC.createMember));
        this.createProject = (this.sendRequest(interfaces_1.WEN_FUNC.createProject));
    }
}
var Build5;
(function (Build5) {
    Build5["PROD"] = "https://api.build5.com";
    Build5["TEST"] = "https://api-test.build5.com";
})(Build5 || (exports.Build5 = Build5 = {}));
exports.SoonaverseApiKey = {
    [Build5.PROD]: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiIweDU1MWZkMmM3YzdiZjM1NmJhYzE5NDU4N2RhYjJmY2Q0NjQyMDA1NGIiLCJwcm9qZWN0IjoiMHg0NjIyM2VkZDQxNTc2MzVkZmM2Mzk5MTU1NjA5ZjMwMWRlY2JmZDg4IiwiaWF0IjoxNzAwMDAyODkwfQ.IYZvBRuCiN0uYORKnVJ0SzT_1H_2o5xyDBG20VmnTQ0',
    [Build5.TEST]: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiIweDU1MWZkMmM3YzdiZjM1NmJhYzE5NDU4N2RhYjJmY2Q0NjQyMDA1NGIiLCJwcm9qZWN0IjoiMHg0NjIyM2VkZDQxNTc2MzVkZmM2Mzk5MTU1NjA5ZjMwMWRlY2JmZDg4IiwiaWF0IjoxNjk1ODUyNTk2fQ.WT9L4H9eDdFfJZMrfxTKhEq4PojNWSGNv_CbmlG9sJg',
};
